import { color, font, fontFamily } from "@smoothincorg/smooth-ui"
import styled, { css } from "styled-components"
import { A } from "../A"

const style = css`
  ${font(14)};
  ${fontFamily.roboto};
  border: 2px solid ${color.mediumLightGray};
  padding: 2px 8px;
  border-radius: 8px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const BorderedButton = styled.button`
  ${style}
`

export const BorderedButtonAnchor = styled(A)`
  ${style}
  text-decoration: none;
  color: #000000;
`
